"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DetailViewIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
}, props));
DetailViewIcon.displayName = 'DetailViewIcon';
var _default = exports.default = DetailViewIcon;